module.exports = __webpack_public_path__ + "img/data-sharing.53d0629a.svg";